type TicketSale = {
    allocated?: number | string | null;
    fixed_tickets?: number;
    [key: string]: unknown;
};

type TicketSeller = {
    name?: string | null;
};

type TicketType = {
    fixed_tickets?: number | string | null;
    sales: TicketSale[];
    [key: string]: unknown;
};

const DIRECT_SALES_NAME = 'direct sales';

const toSafeNumber = (value: unknown): number => {
    const parsed = Number(value);

    if (Number.isFinite(parsed)) {
        return parsed;
    }

    return 0;
};

const isDirectSalesSeller = (seller: TicketSeller | undefined): boolean => {
    if (typeof seller?.name !== 'string') {
        return false;
    }

    return seller.name.trim().toLowerCase() === DIRECT_SALES_NAME;
};

const getFixedTicketsSaleIndex = (ticketType: TicketType, selectedTicketSellers: TicketSeller[]): number => {
    if (!ticketType.sales.length) {
        return -1;
    }

    const directSalesSaleIndex = selectedTicketSellers.findIndex((seller, index) => {
        const sale = ticketType.sales[index];

        return sale !== undefined && isDirectSalesSeller(seller) && toSafeNumber(sale.allocated) > 0;
    });

    if (directSalesSaleIndex !== -1) {
        return directSalesSaleIndex;
    }

    const firstAllocatedSaleIndex = ticketType.sales.findIndex((sale) => toSafeNumber(sale.allocated) > 0);

    if (firstAllocatedSaleIndex !== -1) {
        return firstAllocatedSaleIndex;
    }

    return 0;
};

export const assignFixedTicketsToSales = (
    ticketType: TicketType,
    selectedTicketSellers: TicketSeller[]
): TicketSale[] => {
    const sales = ticketType.sales.map((sale) => ({
        ...sale,
        fixed_tickets: 0,
    }));
    const fixedTicketsSaleIndex = getFixedTicketsSaleIndex(
        {
            ...ticketType,
            sales,
        },
        selectedTicketSellers
    );

    if (fixedTicketsSaleIndex === -1) {
        return sales;
    }

    const fixedTicketsSale = sales[fixedTicketsSaleIndex];

    if (fixedTicketsSale === undefined) {
        return sales;
    }

    fixedTicketsSale.fixed_tickets = toSafeNumber(ticketType.fixed_tickets);

    return sales;
};

export const normaliseCreateTicketsPayload = (
    ticketTypes: TicketType[],
    selectedTicketSellers: TicketSeller[]
): TicketType[] => {
    return ticketTypes.map((ticketType) => {
        const payloadTicketType = {
            ...ticketType,
            sales: assignFixedTicketsToSales(ticketType, selectedTicketSellers),
        };

        delete payloadTicketType.fixed_tickets;

        return payloadTicketType;
    });
};
